FD.CONTROL = (function ($, me) {
    'use strict';

    var child = me.CONTROL || {};


    /* ========================================================================
     *  private vars
     * ========================================================================
    */

    //  element
    var ELEM = '[data-fd="status"]';
    var eventsAreSet = false;


    //  color
    var color = {
        nostatus: 'color-transparent',
        red: 'color-red',           //#FB4C4C
        yellow: 'color-yellow',     //#F0EE45
        green: 'color-green',       //#3AD832
        blue: 'color-blue',         //#0072BC
    };


    //  box
    var box = {
        in: 'fa-square',
        out: 'fa-square-o'
    };


    //  defaults
    var defaults = {
        useparent: true,
        parentid: -1,
        callbackprefix: 1,
        tag: 80,
        value: 'nostatus',
        noedit: false,
        type: 'trygb',   //  trygb, rygb, tb, tyb

        reset: function (value) {
            var e = $(this.element);
            e.data().value = value;
            resetStatus(e);
        },
        resetType: function (value, type) {
            var e = $(this.element);
            e.data().value = value;
            e.data().type = type;
            resetStatus(e);
        }
    };


    /* ========================================================================
     *  private methods
     * ========================================================================
    */


    //  set events
    function setEvents() {
        var NAMESPACE = me.getUID('CTRL_');

        //  set event
        $(document).off('click', ELEM).on('click.' + NAMESPACE, ELEM, clickStatus);
    }


    //  get status
    function getStatus(wireEvent, container) {
        var list = '';

        //  set list
        if (container !== null) {
            if (typeof container === 'string') container = $(container);
            list = container.find(ELEM);
        } else {
            list = $(ELEM);
        }


        //  wire events
        if (wireEvent && !eventsAreSet) {
            setEvents();
            eventsAreSet = true;
        }


        //  bail
        if (list.length === 0) {
            return;
        }


        //  element
        list.each(function (i, e) {
            var elem = $(e);

            //  set options
            var options = $.extend({}, defaults, elem.data());


            //  set elem data
            me.setControlItemOptions(elem, options);


            //  set data
            elem.data(options);


            //  reset
            elem.html('').append("<i class='fa fa-fw fa-checkbox-o'></i><input type='hidden' name='" + elem.attr('name') + "' value='" + elem.data("value") + "'/>");
            options.reset(options.value);
            elem.removeAttr('name');

            //  set cursor
            if (!options.noedit) {
                elem.css({ cursor: 'pointer' });
            }
        });
    }


    // reset status
    function resetStatus(e) {
        var data = e.data();
        var value = data.value.toLowerCase();

        //  remove class
        e.removeClass(color.nostatus)
            .removeClass(color.red)
            .removeClass(color.yellow)
            .removeClass(color.green)
            .removeClass(color.blue);

        if (value === 'nostatus') {
            e.children('i').removeClass(box.in).addClass(box.out);
        } else {
            e.children('i').removeClass(box.out).addClass(box.in);
        }

        e.addClass(color[value]);

        switch (value) {
            case 'nostatus':
                data.value = 'NoStatus';
                break;
            case 'red':
                data.value = 'Red';
                break;
            case 'yellow':
                data.value = 'Yellow';
                break;
            case 'green':
                data.value = 'Green';
                break;
            case 'blue':
                data.value = 'Blue';
                break;
            default:
                data.value = 'NoStatus';
        }
        e.find('input').attr('value', data.value);
    }



    //  click status
    function clickStatus() {
        var e = $(this);
        e.data().element = e;

        var data = e.data();

        if (data.noedit) return;

        var value = data.value.toLowerCase();
        var type = data.type.toLowerCase();

        //  trygb
        if (type === 'trygb') {
            switch (value) {
                case 'nostatus':
                    data.value = 'Red';
                    break;
                case 'red':
                    data.value = 'Yellow';
                    break;
                case 'yellow':
                    data.value = 'Green';
                    break;
                case 'green':
                    data.value = 'Blue';
                    break;
                case 'blue':
                    data.value = 'NoStatus';
                    break;
                default:
                    data.value = 'NoStatus';
            }
        }

        if (type === 'tryg') {
            switch (value) {
                case 'nostatus':
                    data.value = 'Red';
                    break;
                case 'red':
                    data.value = 'Yellow';
                    break;
                case 'yellow':
                    data.value = 'Green';
                    break;
                case 'green':
                    data.value = 'NoStatus';
                    break;
                default:
                    data.value = 'NoStatus';
            }
        }

        if (type === 'rygb') {
            switch (value) {
                case 'nostatus':
                    data.value = 'Red';
                    break;
                case 'red':
                    data.value = 'Yellow';
                    break;
                case 'yellow':
                    data.value = 'Green';
                    break;
                case 'green':
                    data.value = 'Blue';
                    break;
                case 'blue':
                    data.value = 'Red';
                    break;
                default:
                    data.value = 'NoStatus';
            }
        }

        if (type === 'tyb') {
            switch (value) {
                case 'nostatus':
                    data.value = 'Yellow';
                    break;
                case 'yellow':
                    data.value = 'Blue';
                    break;
                case 'blue':
                    data.value = 'NoStatus';
                    break;
                default:
                    data.value = 'NoStatus';
            }
        }

        if (type === 'rg') {
            switch (value) {
                case 'nostatus':
                    data.value = 'Red';
                    break;
                case 'red':
                    data.value = 'Green';
                    break;
                case 'green':
                    data.value = 'NoStatus';
                    break;
                default:
                    data.value = 'NoStatus';
            }
        }

        if (type === 'tb') {
            switch (value) {
                case 'nostatus':
                    data.value = 'Blue';
                    break;
                case 'blue':
                    data.value = 'NoStatus';
                    break;
                default:
                    data.value = 'NoStatus';
            }
        }

        if (type === 'tgyr') {
            switch (value) {
                case 'nostatus':
                    data.value = 'Green';
                    break;
                case 'green':
                    data.value = 'Yellow';
                    break;
                case 'yellow':
                    data.value = 'Red';
                    break;
                case 'red':
                    data.value = 'NoStatus';
                    break;
                default:
                    data.value = 'NoStatus';
            }
        }

        e.find('input').attr('value', data.value).trigger('change');

        e.data(data);

        //  reset
        resetStatus(e);

        //  callback
        data = e.data();
        me.setCallBackFromData(e, { e: data.element, value: data.value, tag: data.tag, parentid: data.parentid });
    }




    /* ========================================================================
     *  public methods
     * ========================================================================
    */


    child.setStatus = function(wireEvent, container) {
        getStatus(wireEvent, container);
    }

    /* ========================================================================
     *  return
     * ========================================================================
    */
    return child;
}(jQuery, FD));